import { IconButton, useTheme } from "react-native-paper";

import { EventStatus } from "../../../types";

type Props = {
  status: EventStatus;
};

export default function EventIcon({ status }: Props) {
  const { colors } = useTheme();

  function getIconProps() {
    switch (status) {
      case "completed":
        return {
          icon: "radiobox-marked",
          iconColor: colors.onPrimaryContainer,
          containerColor: colors.surfaceVariant,
        };
      case "processing":
        return {
          icon: "progress-clock",
          iconColor: colors.onTertiaryContainer,
          containerColor: colors.tertiaryContainer,
        };
      case "rejected":
        return {
          icon: "progress-alert",
          iconColor: colors.onErrorContainer,
          containerColor: colors.errorContainer,
        };
    }
  }

  const { icon, iconColor, containerColor } = getIconProps();

  return (
    <IconButton
      icon={icon}
      mode="contained-tonal"
      iconColor={iconColor}
      containerColor={containerColor}
    />
  );
}
